var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDotsHorizontalOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6 13C22.9255 13 24 11.8807 24 10.5C24 9.11929 22.9255 8 21.6 8C20.2745 8 19.2 9.11929 19.2 10.5C19.2 11.8807 20.2745 13 21.6 13Z",
    fill: "#6B7280"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13C13.3255 13 14.4 11.8807 14.4 10.5C14.4 9.11929 13.3255 8 12 8C10.6745 8 9.6 9.11929 9.6 10.5C9.6 11.8807 10.6745 13 12 13Z",
    fill: "#6B7280"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4 13C3.72548 13 4.8 11.8807 4.8 10.5C4.8 9.11929 3.72548 8 2.4 8C1.07452 8 0 9.11929 0 10.5C0 11.8807 1.07452 13 2.4 13Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsHorizontalOutline);
export default __webpack_public_path__ + "static/media/dots-horizontal-outline.f0e7048dd8620d0ff15a71d0674b2fb8.svg";
export { ForwardRef as ReactComponent };